import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import {
  ApiService,
  Room,
  Conference,
  DateTimeFrame,
} from '../../../shared';

@Component({
  selector: 'app-room-schedule-page',
  templateUrl: './room-schedule-page.component.html',
})
export class RoomSchedulePageComponent implements OnInit {
  title: string = 'schedule';
  subtitle: string = 'rivendell'
  room: Room;
  conferences$: Observable<Conference[]>;
  dateTimeFrame$: Observable<DateTimeFrame>;

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.getRoom();
    this.conferences$ = this.getConferences();
    this.dateTimeFrame$ = this.getDateTimeFrame();
    
  }

  getRoom() {
    this.apiService.getRoom(this.activatedRoute.snapshot.params['room'])
      .subscribe(room => {
        this.room = room;
        this.subtitle = room.name;
      })
  }

  getConferences(): Observable<Conference[]> {
    return this.apiService.getRoomConferences(this.activatedRoute.snapshot.params['room']);
  }

  getDateTimeFrame(): Observable<DateTimeFrame> {
    return this.apiService.getDateTimeFrame();
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule/pages/room-schedule-page/room-schedule-page.component.ts